import api from "../../../services/api";

export const getPasswords = () => {
  return api.get("/owner-security");
};

export const getPasswordById = (id) => {
  return api.get(`/owner-security/${id}`);
};

export const createPassword = (data) => {
  return api.post("/owner-security", data);
};

export const updatePassword = (id, data) => {
  return api.put(`/owner-security/${id}`, data);
};

export const disablePassword = (id) => {
  return api.delete(`/owner-security/${id}`);
};
